import React from "react";
import Mascot from "@/components/Mascot";
import { Phone, Mail, MapPin, Fish } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[var(--fc-blue-dark)] text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <Mascot variant="logo" className="h-20 w-auto" />
          </div>
          <p className="mt-5 text-white/85 max-w-md">
            We clean with purpose. We serve with integrity. Faith-based, honest, reliable, and dedicated to excellence —
            proudly based in St. Cloud and serving all of Central Florida.
          </p>
          <div className="mt-6 flex items-center gap-2 text-white/80 text-sm">
            <Fish className="w-4 h-4" /> Faith-Based · Honest · Reliable
          </div>
        </div>

        <div>
          <div className="font-heading text-lg font-bold mb-3">Quick Links</div>
          <ul className="space-y-2 text-white/85">
            <li><a className="hover:text-[var(--fc-yellow)]" href="#services">Services</a></li>
            <li><a className="hover:text-[var(--fc-yellow)]" href="#gallery">Gallery</a></li>
            <li><a className="hover:text-[var(--fc-yellow)]" href="#why">Why Choose Us</a></li>
            <li><a className="hover:text-[var(--fc-yellow)]" href="#estimate">Free Estimate</a></li>
            <li>
              <a
                className="hover:text-[var(--fc-yellow)]"
                href="https://www.google.com/search?sa=X&sca_esv=0444657f1031709e&hl=en&authuser=0&biw=390&bih=699&sxsrf=ANbL-n5AF-t3QSGrTSethgx8G9d2e7KcEQ%3A1781379695575&kgmid=%2Fg%2F11zfq70sdd&q=Faithfully%20Clean%20Pressure%20Washing&shem=epsd1%2Crimspwouoe&shndl=30&source=sh%2Fx%2Floc%2Fact%2Fm4%2F3"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-google"
              >
                Google Reviews
              </a>
            </li>
          </ul>
        </div>

        <div>
          <div className="font-heading text-lg font-bold mb-3">Contact</div>
          <ul className="space-y-3 text-white/85">
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[var(--fc-yellow)]" /> <a href="tel:4073752862">407-375-2862</a></li>
            <li className="flex items-start gap-2"><Mail className="w-4 h-4 text-[var(--fc-yellow)] mt-1" /> <a className="break-all" href="mailto:Faithfullycleansolutionsllc@gmail.com">Faithfullycleansolutionsllc@gmail.com</a></li>
            <li className="flex items-center gap-2"><MapPin className="w-4 h-4 text-[var(--fc-yellow)]" /> Based in St. Cloud · Central Florida</li>
          </ul>
        </div>
      </div>

      <div className="bg-[var(--fc-orange)] text-[var(--fc-blue-dark)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 font-heading font-extrabold uppercase tracking-widest text-center text-sm sm:text-base">
          Cleaner Home · Better Curb Appeal · Faithfully Done!
        </div>
      </div>
      <div className="bg-black/30 text-white/70 text-xs text-center py-3">
        © {new Date().getFullYear()} Faithfully Clean Pressure Washing &amp; Exterior Cleaning. All rights reserved.
      </div>
    </footer>
  );
}
